import React from 'react';
export function AgitationSection() {
  return <section className="py-12 px-4 bg-dark-100" data-id="element-34">
      <div className="max-w-[680px] mx-auto text-center space-y-[12px] text-base text-body leading-[1.5]" data-id="element-35">
        <p data-id="element-36">
          Lo peor no es el ruido. Lo peor es que{' '}
          <span className="text-white font-medium" data-id="element-37">
            ya intentaste callarlo.
          </span>
        </p>

        <p data-id="element-38">
          Meditaste. Leíste los libros. Pusiste alarmas para madrugar. Y siempre
          vuelves al mismo lugar.
        </p>

        <p data-id="element-39">
          Porque el problema no estaba en tus hábitos.{' '}
          <span className="text-white font-medium" data-id="element-40">
            Estaba en tu frecuencia.
          </span>
        </p>

        <p data-id="element-41">
          Mientras tu sistema nervioso opere desde el trauma o el miedo — ningún
          hábito nuevo va a sobrevivir ahí dentro.
        </p>

        <h2 className="text-3xl md:text-4xl font-serif text-gold mt-8 font-bold" data-id="element-42">
          ¿Hasta cuándo?
        </h2>
      </div>
    </section>;
}